import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { OrderPortalGlobalState } from "../../../shared/state/order-portal-global.state";
import { SelectedTenantId } from "../../../shared/state/order-portal-global.actions";

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const tenantId =store.selectSnapshot(OrderPortalGlobalState.TenantId);// "981CEFC1-DECC-403E-8D0B-466E0967593C";
  const locationId=store.selectSnapshot(OrderPortalGlobalState.LocationId)
  const authorize=store.selectSnapshot(OrderPortalGlobalState.Authorize);
  const request = req.clone({
    setHeaders: {
      "tenantId": tenantId ?? "",
      "locationId": locationId ?? "",
      "Authorization":"Bearer "+authorize?.jwtToken
    }
  });
  return next(request);
};
